module.exports = __webpack_public_path__ + "static/preset-footer-1-531e431293ad2c9384a8e51974ba7616.png";